/**
 * ErrorState component - Error display with retry button
 */

import React from 'react';

interface ErrorStateProps {
  message: string;
  onRetry: () => void;
}

const ErrorState: React.FC<ErrorStateProps> = ({ message, onRetry }) => {
  return (
    <div className="outreach-error-state" role="alert">
      <div className="error-icon" aria-hidden="true">
        <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="24" cy="24" r="20" fill="#FEE2E2" />
          <path d="M24 16V26M24 32H24.02" stroke="#DC2626" strokeWidth="2" strokeLinecap="round" />
        </svg>
      </div>
      <p className="error-message">{message}</p>
      <button
        className="retry-button"
        onClick={onRetry}
        aria-label="Retry loading folders"
      >
        Retry
      </button>
    </div>
  );
};

export default ErrorState;

